import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

// custom code for additional Inpost field at cart
document.addEventListener('DOMContentLoaded', function() {

    // --- Inject our CSS rule ---
    // We use !important to override any conflicting theme styles.
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = ".parcel-field-hidden { display: none !important; }";
    document.head.appendChild(styleSheet);
    
    /**
     * NEW FUNCTION: Saves the parcel code attribute to the cart
     * using the Shopify Cart API
     */
    async function saveParcelAttribute(event) {
        const newCode = event.target.value;
        try {
            // Send the attribute to Shopify's cart
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "attributes": {
                        "paczkomat-inpost": newCode
                    }
                })
            });
        } catch (error) {
            // Silently catch errors in production
        }
    }

    /**
     * Checks the cart contents and shows/hides the parcel field.
     * This version fetches product data for each item to reliably get tags.
     */
    async function checkCartAndToggleParcelField() {
        try {
            // 1. Fetch the current cart data
            const response = await fetch('/cart.js');
            if (!response.ok) {
                return;
            }
            const cart = await response.json();

            let shouldHide = false;
            
            // 2. Check if any item in the cart has the 'zdp-true' tag
            if (cart.items && cart.items.length > 0) {
                const productFetchPromises = cart.items.map(item => {
                    return fetch(`/products/${item.handle}.js`).then(res => {
                        if (res.ok) return res.json();
                        return null; // Return null on failure
                    });
                });
                const products = await Promise.all(productFetchPromises);
                shouldHide = products.filter(Boolean).some(product => {
                    return product.tags && Array.isArray(product.tags) && product.tags.includes('zdp-true');
                });
            } else {
                shouldHide = false;
            }

            // 3. Find the wrapper elements
            const parcelFieldWrapper = document.querySelector('.parcel-locker-field-wrapper');
            const parcelFieldInfo = document.querySelector('.parcel-locker-info');
            
            if (parcelFieldWrapper && parcelFieldInfo) {
                
                // 4. Show or hide the field
                if (shouldHide) {
                    parcelFieldWrapper.classList.add('parcel-field-hidden');
                    parcelFieldInfo.classList.remove('parcel-field-hidden');
                    parcelFieldInfo.style.display = 'block'; 
                } else {
                    parcelFieldWrapper.classList.remove('parcel-field-hidden');
                    parcelFieldWrapper.style.display = 'block'; 
                    parcelFieldInfo.classList.add('parcel-field-hidden');
                }

                // --- NEW LOGIC ---
                // 5. Find the input field and attach the save listener
                // We do this here to ensure the field exists and we only attach it once
                const parcelInput = parcelFieldWrapper.querySelector('#CartDrawer-ParcelCode');
                if (parcelInput && !parcelInput.dataset.listenerAttached) {
                    parcelInput.addEventListener('change', saveParcelAttribute);
                    parcelInput.dataset.listenerAttached = 'true'; // Mark as attached
                }
            }

        } catch (error) {
            // Silently catch errors in production
        }
    }

    // --- MutationObserver Setup ---
    let targetNode = document.querySelector('[id*="CartDrawer"], [id*="cart-drawer"], [class*="cart-drawer"], [data-drawer-id="cart"]');
    if (targetNode) {
        const config = { childList: true, subtree: true };
        let debounceTimer;
        const callback = function() {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                checkCartAndToggleParcelField();
            }, 150);
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }

    // --- Initial Run ---
    checkCartAndToggleParcelField();

    // Also listen for Shopify's built-in event as a fallback
    document.addEventListener('cart:updated', function() {
        checkCartAndToggleParcelField();
    });
});

